import React from "react"

const Notification = ({ text, top, left }) => (
    <div className="buy-button__tooltip" style={{ top: `${top}px`, left: `${left}px` }}>
        <div className="buy-button__tooltip-inner">{text}</div>
    </div>
)

export default Notification
